module.exports = __webpack_public_path__ + "img/person-minor.0867f1e0.svg";